import { useInfo } from "@/context/InfoProvider/InfoProvider";
import { useInvestmentLevelsStore } from "@/pages/investment-levels/store/useInvestmentLevelsStore";
import { ComparisonMode } from "@/pages/investment-levels/types/comparisonMode";

import { TransformedExperiment } from "../api/getTestingRecommendations";

/**
 * Hook to setup Investment Levels state for experiment data
 */
export const useNavigateToInvestmentLevels = (): {
  navigateToInvestmentLevels: (experiment: TransformedExperiment) => void;
} => {
  const { nodes } = useInfo();
  const { setTargetNodeUUID, setChannels, setComparisonMode } = useInvestmentLevelsStore();

  const navigateToInvestmentLevels = (experiment: TransformedExperiment) => {
    if (!nodes) {
      return;
    }

    // Find the target node UUID using brand, category, and product from experiment
    const targetNode = nodes.findNodeByBrandCategoryProduct(
      experiment.brand,
      experiment.category,
      experiment.product
    );

    if (targetNode) {
      // Set the target node UUID
      setTargetNodeUUID(targetNode.node.uuid);
    } else {
      // Fallback to default node
      const defaultNodeUUID = nodes?.getHierarchy({ shouldHidePortfolio: true })[0]?.uuid;
      if (defaultNodeUUID) {
        setTargetNodeUUID(defaultNodeUUID);
      }
    }

    // Set channels from experiment BEFORE setting comparison mode
    if (experiment.channels && experiment.channels.length > 0) {
      // Set channels first to ensure they're preserved when Investment Levels loads
      setChannels(experiment.channels);
    }

    // Always set comparison mode to CHANNEL for experiments
    // This ensures the Investment Levels page shows the channel comparison view
    setComparisonMode(ComparisonMode.CHANNEL);
  };

  return { navigateToInvestmentLevels };
};
